import React from "react";
import { renderToString } from "react-dom/server";
import ChrMetricTitle from "../../../../generic/PageUI/Basic/Metric/ChrMetricTitle";
import ChartDataLabel from "./ChartDataLabel";
import i18n from "../../../../../utils/ChrI18n";
import { getExportFileName } from "../../utils";
import { eventTracker, getEventDetails } from "../../../../generic/Utils/eventTracker";
import { isEmpty } from "../../../../../utils/CoreExtensions/ArrayExtensions";
import { metricType } from "../../../../generic/PageUI/constants";
import ChrLink from "../../../../generic/Utils/ChrLink";

const getChartConfigTemplate = function(props = {}) {
  const {
    data,
    color = '#0969DA',
    barPointWidth,
    maxPointWidth = 150,
    height = 300,
    showYaxisLabels = true,
    shouldEnableLinks = true,
    shouldEnableLabelLinks = false,
    xaxisLabelsMetricType = metricType.METRIC,
    showPreviousPeriodDataLabels = true,
    enableMouseTracking = true,
    exportFileName
  } = props;
  const categories = data.map((datum) => {
    return {
      name: datum.name,
      helpText: datum.helpText,
      url: shouldEnableLinks ? datum.url : null
    };
  });

  const getAdditionalEventDetails = function(initialEventDetails){
    const eventDetails = getEventDetails(initialEventDetails);
    eventDetails.payload.source = chrEventConstants.eventLabel.VIEWED_IN_CHART;
    return eventDetails;
  }

  const seriesData = data.map((datum) => {
    return {
      y: datum.data.value,
      alert: datum.data.alert,
      url: shouldEnableLinks ? datum.url : null,
      previousPeriod: datum.data.previousPeriod,
      eventDetails: getAdditionalEventDetails(datum.eventDetails)
    }
  });

  let dataLabels = {
    enabled: true
  };
  if(showPreviousPeriodDataLabels) {
    dataLabels = {
      enabled: true,
      crop: false,
      overflow: "allow",
      useHTML: true,
      formatter: function() {
        return renderToString(<ChartDataLabel basic={this.series?.chart?.options?.chart?.forExport
        } value={this.y} renderedAsString alert={this.point?.alert} previousPeriod={this.point?.previousPeriod} />)
      }
    }
  }

  return {
    chart: {
      height: `${height}px`,
      events: {
        exportData: function (data) {
          data.dataRows.forEach((dataRow, index) => {
            index && (dataRow[0] = dataRow[0]?.name);
          });
        },
        render: function () {
          jQuery('.popover').remove();
          jQuery(".cjs-manual-react-popover").popover();
        }
      }
    },
    title: { text: null },
    legend: { enabled: false },
    credits: { enabled: false },
    tooltip: { enabled: false },
    xAxis: {
      categories: categories,
      lineWidth: 0,
      title: { text: null },
      labels: {
        useHTML: true,
        enabled: true,
        formatter: function() {
          const labelElement = <ChrMetricTitle type={xaxisLabelsMetricType} helpText={this.value.helpText} forceTooltip className="justify-content-center" children={this.value.name} />

          if (shouldEnableLabelLinks && this.value.url) {
            return renderToString(
              <ChrLink href={this.value.url} className='text-primary' newTab>
                {labelElement}
              </ChrLink>
            );
          }
          return renderToString(labelElement);
        }
      },
    },
    yAxis: {
      title: { text: null },
      gridLineDashStyle: 'longdash',
      labels: {
        enabled: showYaxisLabels
      },
      tickAmount: isEmpty(seriesData) ? 3 : null,
      max: isEmpty(seriesData) ? 2 : null
    },
    plotOptions: {
      column: {
        pointPadding: 0,
        borderWidth: 0,
        maxPointWidth: maxPointWidth
      },
      bar: {
        pointWidth: barPointWidth,
      },
      series: {
        enableMouseTracking,
        borderRadius: 4,
        dataLabels: dataLabels,
        color: color,
        cursor: shouldEnableLinks ? "pointer" : null,
        point: {
          events: {
            click: function (_event) {
              if(this.url) {
                window.open(this.url);
                eventTracker(this.eventDetails.eventName, this.eventDetails.payload);
              }
            }
          }
        }
      }
    },
    exporting: {
      filename: getExportFileName(exportFileName)
    },
    series: [{
      data: seriesData,
      name: i18n.t("display_string.Count")
    }],
    lang: {
      noData: i18n.t('common_text.info.No_data_available')
    }
  };
}

export default getChartConfigTemplate;
